import { Grid, Button, Paper } from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import PropTypes from "prop-types";
import React from "react";
import { translate } from "react-i18next";
import { connect } from "react-redux";
import Loading from "../../loading";
import Snackbar from "../../snackbar";
import { styles } from "./style";
import moment from "moment";
import DatePicker from "react-datetime";
import AddPayment from "./addPayment";
import { rateUSD } from "../../../utils/setting";
import InputFormat from "../../../partials/inputForm";
// import Payment from '../../payment'
// Component
class Discount extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      haveOwner: false,
      serviceAccount: {},
    };
  }
  componentDidMount() {
    this.getServiceAccount();
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.adminService.no !== this.props.adminService.no) {
      this.getServiceAccount({ serviceCode: nextProps.adminService.no });
    }
  }
  getServiceAccount = async (payload = {}) => {
    let { t, adminService } = this.props;
    if ((adminService && adminService.no) || payload.serviceCode) {
      this.loading.startLoading();
      let check = await this.props.getServiceAccount({
        serviceCode: adminService.no || payload.serviceCode,
      });
      this.loading.stopLoading();
      if (check.code === 1 && check.data) this.setState({ haveOwner: true });
      else if (check.code !== 1)
        this.mSnackbar.handleClick(check.message, "error");
      else if (check.code === 1 && !check.data)
        this.mSnackbar.handleClick(
          t("service_account_spa_has_not_updated_its_account"),
          "error"
        );
    }
  };
  handleChangeValue = (event) => {
    let value = event.target.value;
    let name = event.target.name;
    let { serviceAccount } = this.state;
    serviceAccount[name] = value;
    this.setState({ ...serviceAccount });
  };
  handleChangeDate = (name, date) => {
    let milisecondInLocal =
      date && date._isAMomentObject ? date.valueOf() : moment().valueOf();
    let serviceAccount = this.state.serviceAccount;
    serviceAccount[name] = milisecondInLocal;
    this.setState(serviceAccount);
  };
  addPayment = async (payment) => {
    let { adminService = {} } = this.props;
    let { t } = this.props;
    if (adminService.no) {
      this.AddPayment.handleDialogClose();
      this.loading.startLoading();
      if (payment.typeMoney === "USD") {
        delete payment.typeMoney;
        payment.receiveMoney = payment.receiveMoney * rateUSD;
      }
      let check = await this.props.addPayment({ ...payment });
      this.loading.stopLoading();
      if (check.code !== 1)
        this.mSnackbar.handleClick(
          check.message || check.error.message,
          "error"
        );
      else {
        this.mSnackbar.handleClick(
          t("service_account_update_service_account_successful")
        );
        this.getServiceAccount();
      }
    }
  };
  render() {
    const { classes, t, i18n } = this.props;
    let { haveOwner } = this.state;
    let { balance } = this.state.serviceAccount;
    return (
      <Paper className={classes.root}>
        <AddPayment
          onRef={(id) => (this.AddPayment = id)}
          add={this.addPayment}
        />
        <Loading onRef={(id) => (this.loading = id)} />
        <Snackbar onRef={(snackbar) => (this.mSnackbar = snackbar)} />
        <Grid container spacing={3}>
          <Grid item xs={12} sm={6}>
            <InputFormat
              disabled={true}
              required
              label={t("service_account_serviceCode")}
              margin="normal"
              value={this.props.serviceAccount.serviceCode}
              name="serviceCode"
              className={classes.textField}
              InputProps={{
                classes: {
                  inputType: classes.inputType,
                },
              }}
              InputLabelProps={{
                className: classes.label,
              }}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <InputFormat
              disabled={true}
              required
              label={t("service_account_balance")}
              margin="normal"
              value={balance || this.props.serviceAccount.balance}
              name="balance"
              onChange={this.handleChangeValue}
              className={classes.textField}
              InputProps={{
                // inputComponent: NumberFormatCustom,
                classes: {
                  inputType: classes.inputType,
                },
              }}
              InputLabelProps={{
                className: classes.label,
              }}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <DatePicker
              renderInput={(props) => (
                <InputFormat
                  disabled={true}
                  required
                  InputProps={{
                    ...props,
                    classes: {
                      root: classes.customRoot,
                      input: classes.customInput,
                    },
                  }}
                  InputLabelProps={{
                    className: classes.label,
                  }}
                  className={classes.textField}
                  label={t("service_account_createdAt")}
                  margin="normal"
                />
              )}
              className={classes.textField}
              timeFormat="hh:mm A"
              dateFormat="DD/MM/YYYY"
              // onChange={(date) => this.handleChangeDate('createdAt', date)}
              value={this.props.serviceAccount.createdAt}
              // defaultValue={moment().valueOf()}
              locale={i18n.language === "vn" ? "vi" : "en"}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <DatePicker
              renderInput={(props) => (
                <InputFormat
                  disabled={true}
                  required
                  InputProps={{
                    ...props,
                    classes: {
                      root: classes.customRoot,
                      input: classes.customInput,
                    },
                  }}
                  InputLabelProps={{
                    className: classes.label,
                  }}
                  className={classes.textField}
                  label={t("service_account_updatedAt")}
                  margin="normal"
                />
              )}
              className={classes.textField}
              timeFormat="hh:mm A"
              dateFormat="DD/MM/YYYY"
              // onChange={(date) => this.handleChangeDate('updatedAt', date)}
              value={this.props.serviceAccount.updatedAt}
              // defaultValue={moment().valueOf()}
              locale={i18n.language === "vn" ? "vi" : "en"}
            />
          </Grid>
        </Grid>
        <Grid container spacing={3}>
          <Grid item xs={12} sm={12}>
            <InputFormat
              required
              disabled={true}
              label={t("service_account_card_number")}
              margin="normal"
              value={this.props.serviceAccount.cardNumber}
              name="cardNumber"
              onChange={this.handleChangeValue}
              className={classes.textField}
              InputProps={{
                // inputComponent: NumberCardFormat,
                classes: {
                  inputType: classes.inputType,
                },
              }}
              InputLabelProps={{
                className: classes.label,
              }}
            />
          </Grid>
          <Grid item xs={12} sm={12}>
            <InputFormat
              disabled={true}
              required
              label={t("service_account_card_name")}
              margin="normal"
              value={this.props.serviceAccount.cardName}
              name="cardName"
              onChange={this.handleChangeValue}
              className={classes.textField}
              InputProps={{
                classes: {
                  inputType: classes.inputType,
                },
              }}
              InputLabelProps={{
                className: classes.label,
              }}
            />
          </Grid>
          <Grid item xs={12} sm={12}>
            <DatePicker
              renderInput={(props) => (
                <InputFormat
                  disabled={true}
                  required
                  InputProps={{
                    ...props,
                    classes: {
                      root: classes.customRoot,
                      input: classes.customInput,
                    },
                  }}
                  InputLabelProps={{
                    className: classes.label,
                  }}
                  className={classes.textField}
                  label={t("service_account_card_expired")}
                  margin="normal"
                />
              )}
              className={classes.textField}
              timeFormat="hh:mm A"
              dateFormat="DD/MM/YYYY"
              onChange={(date) => this.handleChangeDate("cardExpired", date)}
              value={this.props.serviceAccount.cardExpired}
              locale={i18n.language === "vn" ? "vi" : "en"}
            />
          </Grid>
          <Grid item xs={12} sm={12}>
            <InputFormat
              disabled={true}
              required
              label={t("service_account_card_cvv")}
              margin="normal"
              value={this.props.serviceAccount.cardCVV}
              name="cardCVV"
              onChange={this.handleChangeValue}
              className={classes.textField}
              InputProps={{
                classes: {
                  inputType: classes.inputType,
                },
              }}
              InputLabelProps={{
                className: classes.label,
              }}
            />
          </Grid>
        </Grid>
        <Grid
          container
          spacing={3}
          style={{ marginTop: 16 }}
          justify="flex-end"
        >
          <Button
            disabled={haveOwner ? false : true}
            variant="contained"
            color="primary"
            onClick={() => this.AddPayment.handleDialogOpen()}
            className={classes.button}
          >
            {t("service_account_add_payment")}
          </Button>
        </Grid>
      </Paper>
    );
  }
}

Discount.propTypes = {
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired,
};

const mapState = (state) => ({
  adminService: state.service.adminService ? state.service.adminService : {},
  serviceAccount: state.serviceAccount.serviceAccount,
});

const mapDispatch = (dispatch) => ({
  getServiceAccount: dispatch.serviceAccount.getServiceAccount,
  addPayment: dispatch.serviceAccount.addPayment,
});

export default connect(
  mapState,
  mapDispatch
)(translate("translations")(withStyles(styles, { withTheme: true })(Discount)));
